module.exports = __webpack_public_path__ + "img/supervision_640.af2dc3c2.png";